import React, { useEffect, useState } from 'react'
import PersonalDetailsReport from '../AppplicationForm/PersonalDetailsReport'
import { CommonAxiosGet } from '../../../CommonUtilities/CommonAxios/CommonAxios'
import { config } from '../../../CommonUtilities/CommonUrl/CommonUrls'
import { FaCopy } from 'react-icons/fa';
import { Col, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { IoCheckmarkSharp } from "react-icons/io5";

export default function ProfilePage() {
    let navigate = useNavigate();

    const [showData, setData] = useState()
    function getData() {
        let Url = config.url.CONTEXT_READ_URL + "candidate-details"
        CommonAxiosGet(Url).then((res) => {
            if (res?.data?.status === true) {
                setData(res?.data?.data[0])
            }
        })
    }

    useEffect(() => { getData() }, [])
    const [copied, setCopied] = useState(false);
    const handleCopyText = () => {
        const textToCopy = document.getElementById('textToCopy').innerText;
        navigator.clipboard.writeText(textToCopy)
            .then(() => {
                setCopied(true);
                setTimeout(() => {
                    setCopied(false);
                }, 3000);
            })
            .catch(err => {
                console.error('Failed to copy text: ', err);
            });
    };
    return (
        <React.Fragment >

            <Row>
                <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="page-titlespacing d-flex justify-content-between px-0">
                    <div className="heading-main mt-5">
                        <h3 className="main-title">Candidate Id  - <span className='text-danger' id='textToCopy'>{showData?.candidate_id}</span>
                            &nbsp;


                            {copied ? <><IoCheckmarkSharp color='green' size={30} />Copied! </> : <FaCopy onClick={() => { handleCopyText(); }} />}


                        </h3>
                    </div>
                    <div className="text-right mt-5">
                        <button type='button' className="btn btn-secondary btn-sm" onClick={() => { navigate(-1) }}>Back</button>
                    </div>
                </Col>
            </Row>
            <PersonalDetailsReport
                showdata={showData} preview={true} />


        </React.Fragment>
    )
}
